/** @format */

import React, { useEffect, useState } from 'react';
import LeftArrowButton from '../Buttons/LeftArrowButton';
import RightArrowButton from '../Buttons/RightArrowButton';
import I18n from '../Translate/I18n';
import Button from '@material-ui/core/Button';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

interface FakePaginationInterface {
    classes: any;
    children: React.ReactNodeArray;
    elementsPerPage?: number;
    withDetails?: boolean;
}

const FakePagination = (props: FakePaginationInterface): React.ReactElement => {
    const { classes, withDetails } = props;
    const [elementsPerPage, setElementsPerPage] = useState<number>(props.elementsPerPage ?? 20);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [elementsCount, setElementsCount] = useState<number>(0);
    const [fieldPageValue, setFieldPageValue] = useState<number | string>(1);

    const goToBeforePage = (): void => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            setFieldPageValue(currentPage - 1);
        }
    };

    const goToNextPage = (): void => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            setFieldPageValue(currentPage + 1);
        }
    };

    const goToLastPage = (): void => {
        setCurrentPage(totalPages);
        setFieldPageValue(totalPages);
    };

    const handleKeyDown = (e: any): void => {
        if (e.key === 'Enter') {
            if (fieldPageValue === '') {
                return;
            }
            setCurrentPage(typeof fieldPageValue === 'string' ? parseInt(fieldPageValue) : fieldPageValue);
        }
    };

    const editTextField = (e: any): void => {
        const value = e.target.value;
        const rgxAsStr = `^[0-9]+$`;
        const rgx = new RegExp(rgxAsStr);

        if (!value.match(rgx) && value !== '') {
            return;
        }
        if ((parseInt(value) > totalPages || parseInt(value) < 1) && value !== '') {
            return;
        }
        setFieldPageValue(value);
    };

    useEffect(() => {
        if (currentPage !== fieldPageValue && fieldPageValue !== '') {
            setCurrentPage(currentPage);
        }
    }, [currentPage, fieldPageValue]);

    useEffect(() => {
        if (props.children && props.children.length !== elementsCount) {
            setTotalPages(Math.floor(props.children.length / elementsPerPage) + 1);
            setElementsCount(props.children.length);
            setCurrentPage(1);
        }
    }, [elementsPerPage, elementsCount, props.children]);

    return (
        <React.Fragment>
            {props.children.slice((currentPage - 1) * 20, (currentPage - 1) * 20 + elementsPerPage)}

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: 10 }}>
                    <LeftArrowButton disabled={currentPage === 1} callback={goToBeforePage} callbackParam={{}} />
                </div>
                <React.Fragment key={'goToPage'}>
                    <TextField
                        onChange={editTextField}
                        onKeyDown={handleKeyDown}
                        variant={'filled'}
                        classes={classes.paginatorTextField}
                        value={fieldPageValue}
                        inputProps={{
                            className: classes.paginatorInputStyle,
                        }}
                        InputProps={{
                            className: classes.paginatorLabelStyle,
                        }}
                    />
                    <I18n trans={'general:common.from_page'} />
                    <Button disabled={currentPage === totalPages} variant={'text'} disableRipple onClick={goToLastPage} className={classes.lastPage}>
                        {totalPages}
                    </Button>
                </React.Fragment>

                <RightArrowButton disabled={currentPage === totalPages} callback={goToNextPage} callbackParam={{}} />
            </div>
            {withDetails && elementsCount > 0 && (
                <ul className={classes.pagination} style={{ paddingTop: "paddingTop: '0.4em'", display: 'block', margin: '0px 10px' }}>
                    <li className={classes.paginationItem}>
                        <I18n
                            trans="general:common.view_page_from_to_all"
                            valueObject={{
                                fromPage: (currentPage - 1) * 20,
                                toPage: (currentPage - 1) * 20 + elementsPerPage,
                                totalItems: elementsCount,
                            }}
                        />
                    </li>
                </ul>
            )}
        </React.Fragment>
    );
};

export default withStyles(OplAppStyle)(FakePagination);
